import React, { useEffect, useState } from "react";
import { auth, db } from "../../firebase";
import { createUserWithEmailAndPassword, signOut } from "firebase/auth";
import {
  collection,
  getDocs,
  updateDoc,
  deleteDoc,
  doc,
  setDoc,
  addDoc,
  Timestamp,
} from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import { onAuthStateChanged } from "firebase/auth";
import { secondaryAuth } from "../../firebase"; // import it
import { getDoc } from "firebase/firestore";
import { Modal, Button } from "react-bootstrap"; // Or use your modal package
import BulkOrderRequests from "../orders/BulkOrderRequests";
import AddAgentForm from "./AddAgentForm";
import AgentList from "./AgentList";
import AddCredits from "../transactions/AddCredits";
import CreditRequestList from "../transactions/CreditRequestList";
import CreditRequests from "../transactions/CreditRequests";
import PriceConfigure from "../configure/PriceConfigure";
import WebsiteConfigure from "../configure/WebsiteConfigure";
import UsersList from "./UsersList";

const AdminDashboard = () => {
  const [agents, setAgents] = useState([]);
  const [view, setView] = useState("add");
  const [message, setMessage] = useState("");
  const [filters, setFilters] = useState({
    district: "",
    mandal: "",
    area: "",
  });
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedAgent, setSelectedAgent] = useState(null);
  const [creditData, setCreditData] = useState({
    credits: 50,
    paymentMode: "cash",
    remarks: "",
    utrId: "",
  });

  const [loading, setLoading] = useState(true);
  const [isAdmin, setIsAdmin] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);

  const [activeTab, setActiveTab] = useState("dashboard");
  const [creditRequests, setCreditRequests] = useState([]);
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [elementId, setElementId] = useState();

  useEffect(() => {
    const fetchRequests = async () => {
      const snapshot = await getDocs(collection(db, "creditRequests"));
      const data = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
      setCreditRequests(data);
    };
    fetchRequests();
  }, []);

  useEffect(() => {
    onAuthStateChanged(auth, (user) => {
      console.log("Current user:", user);
    });
  }, []);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        setCurrentUser(user);
        const userDoc = await getDoc(doc(db, "users", user.uid));
        const role = userDoc.exists() ? userDoc.data().role : null;
        if (role === "admin") {
          setIsAdmin(true);
        }
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  const [newAgent, setNewAgent] = useState({
    email: "",
    password: "",
    name: "",
    contact: "",
    credits: 0,
    area: "",
    mandal: "",
    district: "",
    state: "",
  });

  const totalAgents = agents.length;
  const activeAgents = agents.filter((a) => a.isActive).length;
  const inactiveAgents = totalAgents - activeAgents;

  const handleApproval = async (action) => {
    try {
      const docRef = doc(db, "creditRequests", selectedRequest.id);
      const updateData = {
        status: action,
        [`${action}At`]: Timestamp.now(),
      };

      await updateDoc(docRef, updateData);

      if (action === "approved") {
        // Update agent's credits
        const agentRef = doc(db, "users", selectedRequest.uid);
        const agentSnap = await getDoc(agentRef);
        if (agentSnap.exists()) {
          const agentData = agentSnap.data();
          await updateDoc(agentRef, {
            credits: agentData.credits + selectedRequest.credits,
          });
        }
      }

      setShowModal(false);
      setCreditRequests((prev) =>
        prev.map((r) =>
          r.id === selectedRequest.id ? { ...r, ...updateData } : r
        )
      );
      alert(`Request ${action} successfully.`);
    } catch (error) {
      console.error("Error updating request:", error);
      alert("Failed to update request.");
    }
  };

  const navigate = useNavigate();

  const generateAccountId = () =>
    Math.floor(100000 + Math.random() * 900000).toString();

  const generateTransactionId = () => {
    const now = new Date();
    const timestamp = now
      .toISOString()
      .replace(/[-T:.Z]/g, "")
      .slice(2, 14);
    const randomDigits = Math.floor(10000000 + Math.random() * 90000000);
    return `${timestamp}${randomDigits}`;
  };

  const fetchAgents = async () => {
    try {
      const currentUser = auth.currentUser;
      if (!currentUser) {
        console.log("No authenticated user. Skipping fetchAgents.");
        return;
      }

      const querySnapshot = await getDocs(collection(db, "users"));
      const data = querySnapshot.docs
        .map((doc) => ({ id: doc.id, ...doc.data() }))
        .filter((user) => user.role === "agent");
      setAgents(data);
    } catch (error) {
      console.error("Error fetching agents:", error.message);
    }
  };

  const handleLogout = async () => {
    await signOut(auth);
    navigate("/login");
  };

  fetchAgents();

  const handleAddCreditCTAClick = () => {
    setElementId("showcreditfrom");
  };
  const handleAddCreditCTAClickHide = () => {
    setElementId("");
  };

  const addAgent = async () => {
    try {
      const userCredential = await createUserWithEmailAndPassword(
        secondaryAuth,
        newAgent.email,
        newAgent.password
      );

      const user = userCredential.user;
      const accountId = generateAccountId();

      await setDoc(doc(db, "users", user.uid), {
        uid: user.uid,
        accountId,
        username: newAgent.name,
        email: newAgent.email,
        contact: newAgent.contact,
        role: "agent",
        credits: Number(newAgent.credits),
        area: newAgent.area,
        mandal: newAgent.mandal,
        district: newAgent.district,
        state: newAgent.state,
        isActive: true,
        downloads: [],
      });

      // Sign out from the secondary app to avoid switching sessions
      await signOut(secondaryAuth);

      setMessage("Agent created successfully.");
      setNewAgent({
        email: "",
        password: "",
        name: "",
        contact: "",
        credits: 0,
        area: "",
        mandal: "",
        district: "",
        state: "",
      });

      fetchAgents();
    } catch (error) {
      console.error("Error adding agent:", error);
      setMessage("Error: " + error.message);
    }
  };

  const renderAgents = (filter) => {
    return agents
      .filter((agent) => {
        if (filter === "active") return agent.isActive;
        if (filter === "inactive") return !agent.isActive;
        return true;
      })
      .filter((agent) => {
        const { district, mandal, area } = filters;
        return (
          (!district || agent.district === district) &&
          (!mandal || agent.mandal === mandal) &&
          (!area || agent.area === area)
        );
      })
      .map((agent) => (
        <tr key={agent.id}>
          <td>{agent.accountId}</td>
          <td>{agent.username}</td>
          <td>{agent.contact}</td>
          <td>{agent.credits}</td>
          <td>{agent.area}</td>
          <td>{agent.mandal}</td>
          <td>{agent.district}</td>
          <td>{agent.isActive ? "Active" : "Inactive"}</td>
          <td>{agent.printStyle}</td>
          <td>
            <button
              className="btn btn-sm btn-warning"
              onClick={() =>
                updateDoc(doc(db, "users", agent.id), {
                  isActive: !agent.isActive,
                }).then(fetchAgents)
              }
            >
              {agent.isActive ? "Deactivate" : "Activate"}
            </button>
          </td>
        </tr>
      ));
  };

  if (loading) return <p>Loading...</p>;

  if (!currentUser) return <p>You must be logged in to view this page.</p>;

  if (!isAdmin)
    return (
      <p style={{ color: "red", fontWeight: "bold" }}>
        Access Denied: Only Admins can view this page.
      </p>
    );
  return (
    <div className="container-fluid">
      <div className="row vh-100">
        {/* Sidebar */}
        <div className="col-md-3 bg-light p-3">
          <h4>Admin Panel</h4>

          <button
            className="btn btn-outline-primary w-100 my-2"
            onClick={() => setView("agentsAllList")}
          >
            Dashboard
          </button>
          <button
            className="btn btn-outline-primary w-100 my-2"
            onClick={() => setView("userslist")}
          >
            Users List
          </button>

          <button
            className="btn btn-outline-primary w-100 my-2"
            onClick={() => setView("add")}
          >
            Add Agent
          </button>

          <button
            className="btn btn-outline-warning w-100 my-2"
            onClick={() => setView("credits")}
          >
            Add Credits
          </button>

          <button
            className="btn btn-outline-success w-100 my-2"
            onClick={() => setView("viewcreditrequests")}
          >
            View Credit Order Requests
          </button>

          <button
            className="btn btn-outline-success w-100 my-2"
            onClick={() => setView("bulkOrders")}
          >
            View Print Orders Request
          </button>

          <button
            className="btn btn-outline-success w-100 my-2"
            onClick={() => setView("priceconfigure")}
          >
            Price & Coupon Updates
          </button>
          <button
            className="btn btn-outline-success w-100 my-2"
            onClick={() => setView("websiteconfigure")}
          >
            Configure
          </button>

          <button
            className="btn btn-outline-dark w-100 mt-4"
            onClick={handleLogout}
          >
            Logout
          </button>
        </div>

        {/* Main Content */}
        <div className="col-md-9 p-4">
          {view === "add" && <AddAgentForm />}
          {/* {["agentsAllList", "active", "inactive"].includes(view) && (
            <AgentList />
          )} */}
          {view === "agentsAllList" && <AgentList />}
          {view === "usersList" && <UsersList />}

          {view === "viewcreditrequests" && <CreditRequests />}

          {view === "bulkOrders" && <BulkOrderRequests />}
          {view === "priceconfigure" && <PriceConfigure />}
          {view === "websiteconfigure" && <WebsiteConfigure />}
          {view === "userslist" && <UsersList />}

          {/* {view === "credits" && <AddCredits />} */}

          {view === "credits" && (
            <>
              <h3>Add Credits</h3>
              <input
                className="form-control mb-3"
                placeholder="Search by Account ID, Name, or User ID"
                value={searchTerm}
                onChange={(e) => {
                  setSearchTerm(e.target.value);
                  const match = agents.find(
                    (a) =>
                      a.accountId === e.target.value ||
                      a.username
                        .toLowerCase()
                        .includes(e.target.value.toLowerCase()) ||
                      a.uid === e.target.value
                  );
                  setSelectedAgent(match || null);
                }}
              />
              {selectedAgent && (
                <div className="card p-3 mb-3">
                  <div>
                    <div className="d-flex flex-row gap-3">
                      <p className="col-md-4">
                        <strong>Account ID :</strong> {selectedAgent.accountId}
                      </p>
                      <p className="col-md-4">
                        <strong>Name :</strong> {selectedAgent.username}
                      </p>
                      <p className="col-md-4">
                        <strong>Available Credits : </strong>{" "}
                        {selectedAgent.credits}
                      </p>
                    </div>

                    <div className="d-flex flex-row gap-3">
                      <p className="col-md-4">
                        <strong>Area:</strong> {selectedAgent.area}
                      </p>
                      <p className="col-md-4">
                        <strong>District:</strong> {selectedAgent.district}
                      </p>
                    </div>
                  </div>
                  {/* <button className="btn btn-primary w-25">Add Credit</button> */}
                  <button
                    className="btn btn-primary w-25"
                    onClick={handleAddCreditCTAClick}
                  >
                    Add Credit
                  </button>
                  {elementId && <div id={elementId}></div>}

                  {elementId === "showcreditfrom" && (
                    <div
                      className="row g-2 mt-5 border rounded"
                      id="addCredit-form"
                    >
                      <div className="col-md-4">
                        <input
                          className="form-control"
                          type="number"
                          placeholder="Credits to Add"
                          value={creditData.credits}
                          onChange={(e) =>
                            setCreditData({
                              ...creditData,
                              credits: Number(e.target.value),
                            })
                          }
                        />
                      </div>
                      <div className="col-md-4">
                        <select
                          className="form-select"
                          value={creditData.paymentMode}
                          onChange={(e) =>
                            setCreditData({
                              ...creditData,
                              paymentMode: e.target.value,
                            })
                          }
                        >
                          <option value="cash">Cash</option>
                          <option value="upi">UPI</option>
                          <option value="bank">Bank</option>
                        </select>
                      </div>
                      {(creditData.paymentMode === "upi" ||
                        creditData.paymentMode === "bank") && (
                        <div className="col-md-4">
                          <input
                            className="form-control"
                            placeholder="UTR ID"
                            value={creditData.utrId}
                            onChange={(e) =>
                              setCreditData({
                                ...creditData,
                                utrId: e.target.value,
                              })
                            }
                          />
                        </div>
                      )}
                      <div className="col-12">
                        <textarea
                          className="form-control"
                          placeholder="Remarks"
                          value={creditData.remarks}
                          onChange={(e) =>
                            setCreditData({
                              ...creditData,
                              remarks: e.target.value,
                            })
                          }
                        />
                      </div>
                      <div className="col-12 mt-2">
                        <button
                          className="btn btn-success"
                          onClick={async () => {
                            const transactionId = generateTransactionId();
                            await addDoc(collection(db, "transactions"), {
                              transactionId,
                              accountId: selectedAgent.accountId,
                              uid: selectedAgent.uid,
                              name: selectedAgent.username,
                              credits: creditData.credits,
                              paymentMode: creditData.paymentMode,
                              remarks: creditData.remarks,
                              utrId: creditData.utrId || null,
                              timestamp: new Date(),
                            });
                            await updateDoc(
                              doc(db, "users", selectedAgent.id),
                              {
                                credits:
                                  Number(selectedAgent.credits) +
                                  Number(creditData.credits),
                              }
                            );
                            setMessage(
                              `Credits added. Transaction ID: ${transactionId}`
                            );
                            setCreditData({
                              credits: 0,
                              paymentMode: "cash",
                              remarks: "",
                              utrId: "",
                            });
                            fetchAgents();
                          }}
                        >
                          Submit
                        </button>
                        <button
                          className="btn btn-secondary ms-2"
                          onClick={handleAddCreditCTAClickHide}
                        >
                          Cancel
                        </button>
                        {message && (
                          <p className="text-success mt-2">{message}</p>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              )}
            </>
          )}

          {/* {selectedRequest && (
            <Modal show={showModal} onHide={() => setShowModal(false)}>
              <Modal.Header closeButton>
                <Modal.Title>Credit Request Details</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <p>
                  <strong>Account ID:</strong> {selectedRequest.accountId}
                </p>
                <p>
                  <strong>Username:</strong> {selectedRequest.username}
                </p>
                <p>
                  <strong>Area:</strong> {selectedRequest.area}
                </p>
                <p>
                  <strong>Credits Requested:</strong> {selectedRequest.credits}
                </p>
                <p>
                  <strong>Amount:</strong> {selectedRequest.amount}
                </p>
                <p>
                  <strong>Status:</strong> {selectedRequest.status}
                </p>
                <p>
                  <strong>Requested At:</strong>{" "}
                  {selectedRequest.timestamp?.toDate().toLocaleString()}
                </p>
                {selectedRequest.approvedAt && (
                  <p>
                    <strong>Approved At:</strong>{" "}
                    {selectedRequest.approvedAt?.toDate().toLocaleString()}
                  </p>
                )}
                {selectedRequest.rejectedAt && (
                  <p>
                    <strong>Rejected At:</strong>{" "}
                    {selectedRequest.rejectedAt?.toDate().toLocaleString()}
                  </p>
                )}
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="success"
                  onClick={() => handleApproval("approved")}
                  disabled={selectedRequest.status !== "pending"}
                >
                  Approve
                </Button>
                <Button
                  variant="danger"
                  onClick={() => handleApproval("rejected")}
                  disabled={selectedRequest.status !== "pending"}
                >
                  Reject
                </Button>
                <Button variant="secondary" onClick={() => setShowModal(false)}>
                  Close
                </Button>
              </Modal.Footer>
            </Modal>
          )} */}
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
